import { Component, Input } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MediaFileTemplate, MediaRoot } from 'elements-sdk'
import { CustomFieldsService } from 'media.customFields'

@Component({
  selector: 'media-create-from-template-create-modal-component',
  templateUrl: './mediaCreateFromTemplateCreateModal.component.pug',
})
export class MediaCreateFromTemplateCreateModalComponent {
  @Input() fileTemplate: MediaFileTemplate
  @Input() customFieldValues: Record<string, any> = {}
  @Input() root: MediaRoot

  name: string|null
  extension: string|null

  constructor (
    private ngbModal: NgbModal,
    private modalInstance: NgbActiveModal,
    private customFields: CustomFieldsService,
  ) { }

  ngOnInit () {
    this.customFieldValues = this.fileTemplate.file.customFields!

    if (!this.fileTemplate.file.isDir && this.fileTemplate.file.name!.includes('.')) {
      this.name = this.fileTemplate.file.name!.slice(
        0, this.fileTemplate.file.name!.lastIndexOf('.'),
      )
      this.extension = this.fileTemplate.file.name!.slice(
        this.fileTemplate.file.name!.lastIndexOf('.') + 1,
      )
    } else {
      this.name = this.fileTemplate.file.name!
      this.extension = null
    }
  }

  create () {
    if (this.extension) {
      this.name += `.${this.extension}`
    }
    for (const field of this.root.customFields!) {
      const value = this.customFieldValues[field.name!]
      if (value) {
        this.customFields.registerAutocompletion(field as any, value)
      }
    }
    this.modalInstance.close({
      name: this.name,
      customFields: this.customFieldValues,
    })
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
